import { Navigate } from "react-router-dom";

/** Backwards-compat redirect — past vehicles live on My bookings (KAN-67). */
export default function ProfileRented() {
  return <Navigate to="/profile/bookings#past-vehicles" replace />;
}
